import { Link } from "react-router-dom";
import "./Auth.css";

function SignUp() {
  return (
    <div className="auth-container">
      <div className="vintage-corner corner-tl"></div>
      <div className="vintage-corner corner-tr"></div>
      
      <div className="auth-box">
        <div className="auth-header">
          <div className="auth-logo">
            <div className="logo-icon">H</div>
            <div className="logo-text">Haqtri</div>
          </div>
          <h2>Create Your Account</h2>
          <p>Join Nigeria's premier real estate community</p>
        </div>
        
        <form className="auth-form">
          <div className="form-group">
            <label>Full Name</label>
            <input type="text" placeholder="Enter your full name" required />
            <i className="fas fa-user"></i>
          </div>
          <div className="form-group">
            <label>Email</label>
            <input type="email" placeholder="Enter your email" required />
            <i className="fas fa-envelope"></i>
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" placeholder="Create a password" required />
            <i className="fas fa-lock"></i>
          </div>
          <button type="submit" className="auth-btn">
            <span>Sign Up</span>
            <i className="fas fa-arrow-right"></i>
          </button>
        </form>
        
        <div className="auth-divider">
          <span>Or continue with</span>
        </div>
        
        <div className="social-auth">
          <button className="social-btn google-btn">
            <i className="fab fa-google"></i>
            Google
          </button>
          <button className="social-btn facebook-btn">
            <i className="fab fa-facebook-f"></i>
            Facebook
          </button>
        </div>
        
        <p className="auth-footer">
          Already have an account? <Link to="/signin">Sign In</Link>
        </p>
      </div>
      
      <div className="vintage-corner corner-bl"></div>
      <div className="vintage-corner corner-br"></div>
    </div>
  );
}

export default SignUp;